import { createStyles, Box, List, makeStyles, Theme, Typography } from '@agentnet/components';
import { ArrowBack } from '@material-ui/icons';
import { Link, useHistory } from 'react-router-dom';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import useBaseRoute from '../../hooks/useBaseRoute';
import { Article, Topic } from '../../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    topicHeading: {
      alignSelf: 'stretch',
      '&:hover': {
        opacity: '0.9',
      },
    },
    li: {
      display: 'flex',
      paddingBottom: '0px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2, 0),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    a: { textDecoration: 'none' },
    nav: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    mb2: {
      marginBottom: theme.spacing(2),
      justifyContent: 'flex-start',
    },
  }),
);
function TopicContentBody({ topic }: { topic: Topic }) {
  const classes = useStyles();
  const { url } = useBaseRoute();
  const history = useHistory();

  return (
    <div className={classes.container}>
      <AgentNetButton
        className={classes.mb2}
        variant="text"
        size="medium"
        color="primary"
        startIcon={<ArrowBack htmlColor="primary" />}
        onClick={() => history.goBack()}
      >
        Back
      </AgentNetButton>
      <Box mb={2}>
        <Typography variant="h1">{topic?.topicName}</Typography>
      </Box>
      <List component={'nav'} className={classes.nav}>
        {topic?.linkedFrom?.ansArticleCollection?.items?.map((article: Article) => (
          <li key={article.articleTitle} data-testid={`${article.articleTitle}-list-item`} className={classes.li}>
            <Link key={article.articleTitle} to={`${url}/${article.slug}`} className={classes.a}>
              <Typography variant="h3" color="primary" className={classes.topicHeading}>
                {article.articleTitle}
              </Typography>
            </Link>
            <Box mt={1} mb={2}>
              <Typography variant="body2" color="textPrimary">
                {article.articleSummary}
              </Typography>
            </Box>
          </li>
        ))}
      </List>
    </div>
  );
}

export { TopicContentBody };
